'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbSearchFormV2Controller.$inject = ['SearchConstants', '$attrs', 'Relay42Service', '$window', '$interval'];


var _module = _angular2.default.module('cb.core.search.cbSearchFormV2Controller', []);

_module.controller('cbSearchFormV2Controller', cbSearchFormV2Controller);

exports.default = _module;


function cbSearchFormV2Controller(SearchConstants, $attrs, Relay42Service, $window, $interval) {
    var vm = this;

    //vars
    vm.attr = $attrs;
    vm.searchUrl = searchUrl();

    function searchUrl() {
        var resultpage = vm.attr.resultpage || '';

        if (resultpage === vm.attr.resultpage) {
            vm.searchUrl = resultpage;
        } else {
            vm.searchUrl = '/zoek/Paginas/zoeken.aspx#q=';
        }
        return vm.searchUrl;
    }

    $('.sc-input--enterfunctie').keypress(function (e) {
        if (e.which === 13) {
            $(this).closest('.cb-search-form').find('.sc-icon').click();
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/search-v2/cb-search-form-v2.controller.js
// module id = 815
// module chunks = 0